import { useEffect } from 'react';

const ComingSoonModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full z-[9999] flex items-center justify-center opacity-100 visible pointer-events-auto transition-opacity duration-300">
      {/* Overlay */}
      <div
        className="absolute top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.85)] backdrop-blur-sm cursor-pointer"
        onClick={onClose}
      />

      {/* Content */}
      <div className="relative bg-white p-6 md:p-8 w-[350px] h-[350px] flex flex-col items-center justify-center z-10 text-center shadow-[0_20px_60px_rgba(0,0,0,0.3)] transform scale-100 translate-y-0 transition-all duration-300 rounded-lg">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 bg-transparent border-none text-[var(--text-medium)] text-xl cursor-pointer w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 hover:bg-[var(--bg-light)] hover:text-[var(--accent-color)] hover:rotate-90"
          aria-label="Close modal"
        >
          ×
        </button>

        {/* Icon */}
        <div className="mx-auto mb-4 text-[var(--accent-color)] flex items-center justify-center">
          <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-semibold text-[var(--text-dark)] mb-3 uppercase tracking-[2px] font-sans">
          Coming Soon
        </h2>

        {/* Message */}
        <p className="text-sm md:text-base leading-relaxed text-[var(--text-medium)] mb-2 font-serif">
          We're working on something <strong className="text-[var(--text-dark)] font-semibold">amazing</strong> for you!
        </p>

        <p className="text-xs md:text-sm text-[var(--text-light)] mb-6 italic font-serif">
          Stay tuned for updates on our new platform.
        </p>

        {/* Button */}
        <button
          onClick={onClose}
          className="py-2.5 px-8 bg-[var(--text-dark)] text-white border border-[var(--text-dark)] rounded-none font-semibold uppercase tracking-[2px] cursor-pointer text-sm transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] font-sans relative overflow-hidden hover:text-white hover:-translate-y-0.5 hover:shadow-lg before:content-[''] before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-[var(--accent-color)] before:transition-[left] before:duration-500 before:ease-[cubic-bezier(0.4,0,0.2,1)] before:-z-10 hover:before:left-0"
        >
          Got It!
        </button>
      </div>
    </div>
  );
};

export default ComingSoonModal;
